import script from "./FeaturedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedContent.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedContent.vue?vue&type=style&index=0&id=dbadb2d2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbadb2d2"]])

export default __exports__